/**
 * Product Gallery
 */

// Vendors
import $ from 'jquery';
import 'jquery.scrollto/jquery.scrollTo.min';
import toggles from '../framework/toggle';
import { scrollToElement } from '../lib/utilities';

let productGalleryIsTransitioning = false;

$('.gallery-propane-products__item').on('click', (event) => {
  event.preventDefault();

  if (productGalleryIsTransitioning) {
    return false;
  }

  const product = $(event.currentTarget);
  const productId = product.data('propane-product-id');
  const productOffsetTop = product.offset().top;
  const gallery = product.closest('.gallery-propane-products');
  const grid = gallery.find('.gallery-propane-products__grid');
  const detailsContainer = gallery.find(
    '.gallery-propane-products__details-container'
  );
  const details = detailsContainer.find(
    `[data-propane-product-id="${productId}"]`
  );
  const previousProduct = gallery.find(
    '.gallery-propane-products__item--active'
  );
  const previousProductOffsetTop = previousProduct.length
    ? previousProduct.offset().top
    : -1;
  const previousDetails = detailsContainer.find(
    '.gallery-propane-products__details--active'
  );
  const transitionDuration = 300;
  let detailsContainerDetached;
  let lastProductInRow;

  productGalleryIsTransitioning = true;

  if (product.hasClass('gallery-propane-products__item--active')) {
    product.removeClass('gallery-propane-products__item--active');
    $(
      '[data-toggle-target="gallery-propane-product-details-container"]'
    ).trigger('toggle:hide');

    setTimeout(() => {
      gallery.append(detailsContainer.detach());
      gallery.removeClass('gallery-propane-products-item-is-active');
      previousDetails.removeClass('gallery-propane-products__details--active');
      productGalleryIsTransitioning = false;
    }, transitionDuration);
  } else {
    let row = gallery
      .find('.gallery-propane-products__item')
      .filter((index, element) => {
        return $(element).offset().top === productOffsetTop;
      });

    lastProductInRow = row.last();

    if (productOffsetTop !== previousProductOffsetTop) {
      $(
        '[data-toggle-target="gallery-propane-product-details-container"]'
      ).trigger('toggle:hide');

      setTimeout(
        () => {
          detailsContainerDetached = detailsContainer.detach();

          product.addClass('gallery-propane-products__item--active');
          details.addClass('gallery-propane-products__details--active');
          gallery.addClass('gallery-propane-products-item-is-active');
          previousProduct.removeClass('gallery-propane-products__item--active');
          previousDetails.removeClass(
            'gallery-propane-products__details--active'
          );

          if (lastProductInRow.length) {
            lastProductInRow.after(detailsContainerDetached);
            setTimeout(() => {
              $(
                '[data-toggle-target="gallery-propane-product-details-container"]'
              ).trigger('toggle:show');

              scrollToElement('.gallery-propane-products__details-container');
            }, 50);
          } else {
            product.after(detailsContainerDetached);
            setTimeout(() => {
              $(
                '[data-toggle-target="gallery-propane-product-details-container"]'
              ).trigger('toggle:show');
              scrollToElement('.gallery-propane-products__details-container');
            }, 50);
          }

          setTimeout(() => {
            productGalleryIsTransitioning = false;
          }, transitionDuration);
        },
        gallery.hasClass('gallery-propane-products-item-is-active')
          ? transitionDuration
          : 0
      );
    } else {
      product.addClass('gallery-propane-products__item--active');
      details.addClass('gallery-propane-products__details--active');
      gallery.removeClass('gallery-propane-products--transitioning');
      previousProduct.removeClass('gallery-propane-products__item--active');
      previousDetails.removeClass('gallery-propane-products__details--active');

      scrollToElement('.gallery-propane-products__details-container');

      setTimeout(() => {
        productGalleryIsTransitioning = false;
      });
    }
  }
});
